import axios from "axios";

console.log("REACT_APP_API_BASE_URL:",
    process.env.REACT_APP_API_BASE_URL);
const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/jobs`;

export const fetchJobs = async () => {
    const response = await axios.get(API_URL);
    return response.data;
};

export const fetchJobById = async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
};

export const addJob = async (jobData) => {
    const response = await axios.post(API_URL, jobData);
    return response.data;
};
